var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check_per"},[(_vm.access != '' && _vm.access)?_c('h1',[_vm._v("Camera access forbidden")]):_vm._e(),_c('Loader',{attrs:{"show-loader":_vm.isDataLoading,"isFullPage":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }